/* VYNTE quick add: "From" price + "+" add-to-cart button on mobile product cards (Featured collection tabs). */
(function () {
  var css = '' +
    '.vy-buyrow{display:contents}' +
    '.vy-plus{display:none}' +
    '@media screen and (max-width:749px){' +
    '.vy-buyrow{display:flex;align-items:center;justify-content:space-between;gap:8px;width:100%;margin-top:auto}' +
    '.vy-buyrow [class*="ai-featured-collection__product-price-"]{margin:0!important;text-align:left}' +
    '.vy-from{font-size:.8em;font-weight:400;opacity:.75;margin-right:2px}' +
    '.vy-plus{display:flex;flex:0 0 44px;width:44px;height:44px;border-radius:50%;border:0;background:#9A5F43;color:#fff;align-items:center;justify-content:center;cursor:pointer;padding:0}' +
    '.vy-plus[disabled]{opacity:.6}' +
    '.vy-hascta [class*="ai-featured-collection__product-cta-"]{display:none!important}' +
    '}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var plus = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  var check = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function refreshCartBubble() {
    fetch(root + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (d) {
      var el = document.getElementById('cart-icon-bubble');
      if (!el || !d['cart-icon-bubble']) return;
      var tmp = document.createElement('div'); tmp.innerHTML = d['cart-icon-bubble'];
      var inner = tmp.querySelector('.shopify-section') || tmp;
      el.innerHTML = inner.innerHTML;
    }).catch(function () {});
  }

  function enhance(card) {
    if (card.dataset.vyDone) return;
    card.dataset.vyDone = '1';
    var link = card.querySelector('a[class*="ai-featured-collection__product-title-"]');
    var price = card.querySelector('[class*="ai-featured-collection__product-price-"]');
    if (!link || !price) return;
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (!m) return;
    fetch(root + 'products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var v = (p.variants || []).filter(function (x) { return x.available; })[0];
      if (p.price_varies && !price.querySelector('.vy-from')) {
        var f = document.createElement('span'); f.className = 'vy-from'; f.textContent = 'From';
        price.insertBefore(f, price.firstChild);
      }
      var row = document.createElement('div'); row.className = 'vy-buyrow';
      price.parentNode.insertBefore(row, price); row.appendChild(price);
      if (!v) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'vy-plus'; b.innerHTML = plus;
      b.setAttribute('aria-label', 'Add ' + p.title + ' to cart');
      b.addEventListener('click', function () {
        b.disabled = true;
        fetch(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); }).then(function () {
          b.innerHTML = check; b.setAttribute('aria-label', p.title + ' added to cart');
          refreshCartBubble();
          setTimeout(function () { b.innerHTML = plus; b.disabled = false; b.setAttribute('aria-label', 'Add ' + p.title + ' to cart'); }, 1800);
        }).catch(function () { window.location.href = link.href; });
      });
      row.appendChild(b);
      card.classList.add('vy-hascta');
    }).catch(function () {});
  }

  function run() {
    document.querySelectorAll('a[class*="ai-featured-collection__product-title-"]').forEach(function (a) {
      if (a.parentElement) enhance(a.parentElement);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

/* VYNTE featured product: "Pack size" cards + "How you buy" (one-time vs subscribe & save) */
(function () {
  var css = '' +
    '.vy-legend{display:block;margin:0 0 8px;font-size:12px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:#3B322C}' +
    '.vy-packs .option-container{display:grid!important;grid-template-columns:repeat(3,1fr);gap:8px}' +
    '.vy-packs .option-wrapper{margin:0!important;width:auto!important}' +
    '.vy-packs input[type=radio]+label{display:flex!important;flex-direction:column;align-items:center;justify-content:center;gap:2px;width:100%;min-height:74px;padding:10px 6px!important;margin:0!important;border:1px solid #E2D5CB!important;border-radius:12px!important;background:#fff!important;color:#3B322C!important;line-height:1.25;text-align:center;cursor:pointer;box-shadow:none!important}' +
    '.vy-packs input[type=radio]:checked+label{border:2px solid #3B322C!important;padding:9px 5px!important}' +
    '.vy-ps-t{font-size:15px;font-weight:600}.vy-ps-p{font-size:14px}.vy-ps-s{font-size:12px;color:#8C5C40}' +
    '.vy-buy{border:0;padding:0;margin:18px 0 6px;display:grid;gap:8px}' +
    '.vy-opt{display:flex;align-items:center;gap:12px;padding:14px 16px;border:1px solid #E2D5CB;border-radius:12px;background:#fff;color:#3B322C;cursor:pointer}' +
    '.vy-opt.is-on{border:2px solid #3B322C;padding:13px 15px}' +
    '.vy-opt input{position:absolute;opacity:0;width:1px;height:1px}' +
    '.vy-dot{flex:0 0 20px;height:20px;border-radius:50%;border:1.5px solid #B9A99B;display:flex;align-items:center;justify-content:center}' +
    '.vy-opt.is-on .vy-dot{border-color:#9A5F43}.vy-opt.is-on .vy-dot:after{content:"";width:10px;height:10px;border-radius:50%;background:#9A5F43}' +
    '.vy-opt-txt{flex:1;display:flex;flex-direction:column;gap:2px}.vy-opt-txt b{font-size:15px;font-weight:600}.vy-opt-txt small{font-size:12.5px;color:#6B5D53}' +
    '.vy-opt-price{font-size:16px;font-weight:600;white-space:nowrap}' +
    '.vy-opt input:focus-visible~.vy-dot{outline:2px solid #9A5F43;outline-offset:2px}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function money(c) { return '$' + (c / 100).toFixed(2); }

  function setup(sec) {
    var vr = sec.querySelector('variant-radios');
    var form = sec.querySelector('form[id^="product-form-"]') || sec.querySelector('form[action*="/cart/add"]');
    var link = sec.querySelector('a[href*="/products/"]');
    if (!vr || !form || !link || vr.dataset.vyDone) return;
    vr.dataset.vyDone = '1';
    var jsonEl = vr.querySelector('script[type="application/json"]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var handle = link.getAttribute('href').split('?')[0].split('/products/')[1];
    var radios = [].slice.call(vr.querySelectorAll('input[type=radio]'));
    if (!variants.length || !radios.length) return;

    function current() {
      var c = radios.filter(function (r) { return r.checked; })[0];
      return variants.filter(function (v) { return c && v.option1 === c.value; })[0] || variants[0];
    }

    // Keep the variant id (and visible price) in sync with the selected pack size
    function syncVariant() {
      var v = current();
      [].forEach.call(sec.querySelectorAll('input[name="id"]'), function (i) { i.value = v.id; });
      [].forEach.call(sec.querySelectorAll('.price .price-item--regular, .price .price-item--sale'), function (el) { el.textContent = money(v.price); });
    }
    vr.addEventListener('change', function () { setTimeout(syncVariant, 60); });

    // Pack size cards
    var base = variants.filter(function (v) { return v.option1 === '1'; })[0];
    if (base && variants.every(function (v) { return /^\d+$/.test(v.option1); })) {
      vr.classList.add('vy-packs');
      var lg = vr.querySelector('legend'); if (lg) { lg.className = 'vy-legend'; lg.textContent = 'Pack size'; }
      radios.forEach(function (r) {
        var v = variants.filter(function (x) { return x.option1 === r.value; })[0];
        var lab = r.nextElementSibling; if (!v || !lab) return;
        var n = parseInt(v.option1, 10);
        var save = n > 1 ? Math.round((1 - v.price / (base.price * n)) * 100) : 0;
        lab.innerHTML = '<span class="vy-ps-t">' + n + (n === 1 ? ' jar' : ' jars') + '</span>' +
          '<span class="vy-ps-p">' + money(v.price) + '</span>' +
          (save > 0 ? '<span class="vy-ps-s">Save ' + save + '%</span>' : '');
      });
    }

    // How you buy
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var g = (p.selling_plan_groups || [])[0]; var plan = g && g.selling_plans[0];
      if (!plan) return;
      var adj = (plan.price_adjustments || [])[0];
      var pct = adj && adj.value_type === 'percentage' ? adj.value : null;
      var pv = {}; (p.variants || []).forEach(function (v) { pv[v.id] = v; });
      var uid = 'vyb' + Math.random().toString(36).slice(2, 7);
      var box = document.createElement('fieldset'); box.className = 'vy-buy';
      box.innerHTML = '<legend class="vy-legend">How you buy</legend>' +
        '<label class="vy-opt is-on"><input type="radio" name="' + uid + '" value="" checked><span class="vy-dot"></span>' +
        '<span class="vy-opt-txt"><b>One-time purchase</b><small>Ships once</small></span><span class="vy-opt-price" data-k="one"></span></label>' +
        '<label class="vy-opt"><input type="radio" name="' + uid + '" value="' + plan.id + '"><span class="vy-dot"></span>' +
        '<span class="vy-opt-txt"><b>Subscribe &amp; save' + (pct ? ' ' + pct + '%' : '') + '</b><small>Delivered monthly · cancel anytime</small></span><span class="vy-opt-price" data-k="sub"></span></label>';
      vr.parentNode.insertBefore(box, vr.nextSibling);
      var hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.name = 'selling_plan'; hidden.value = '';
      var opts = [].slice.call(box.querySelectorAll('.vy-opt'));

      function refresh() {
        var v = pv[current().id]; if (!v) return;
        var alloc = (v.selling_plan_allocations || []).filter(function (a) { return a.selling_plan_id === plan.id; })[0];
        box.querySelector('[data-k=one]').textContent = money(v.price);
        box.querySelector('[data-k=sub]').textContent = alloc ? money(alloc.price) : '';
        opts[1].style.display = alloc ? '' : 'none';
        if (!alloc && hidden.parentNode) { opts[0].querySelector('input').checked = true; choose(); }
      }
      function choose() {
        opts.forEach(function (o) { o.classList.toggle('is-on', o.querySelector('input').checked); });
        var val = box.querySelector('input:checked').value;
        if (val) { hidden.value = val; if (!hidden.parentNode) form.appendChild(hidden); }
        else if (hidden.parentNode) { hidden.parentNode.removeChild(hidden); }
      }
      box.addEventListener('change', choose);
      vr.addEventListener('change', function () { setTimeout(refresh, 30); });
      refresh();
    }).catch(function () {});
  }

  function run() { document.querySelectorAll('.section-featured-product').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
